(function(){
  class FocusTrap {
    /**
     * Creates an instance of FocusTrap
     * @param {Node} element
     * @param {Object} [options={}]
     * @memberof FocusTrap
     */
    constructor(element, options = {}) {
      // Check if the element is a DOM node
      if (!(element.nodeType === 1)) {
        return new TypeError('Provide an ElementNode');
      }
  
      this._root = element;
  
      this._firstTabStop = null;
      this._lastTabStop = null;
      this.trapped = false;
  
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onMutation = this._onMutation.bind(this);
  
      const observerOptions = Object.assign({}, {
        childList: true,
        attributes: true,
        subtree: true
      }, options);
  
      // Add a MutationObserver to watch for DOM changes
      this.observer = new MutationObserver(this._onMutation);
  
      // Start the observer
      this.observer.observe(this._root, observerOptions);
  
      // Need to update on window resize if any CSS Media Queries might change
      // the visibility and display of focusable elements
      window.addEventListener('resize', this._onMutation);
  
      // Initial setup
      this._onMutation();
    }
  
    _onMutation() {
      // Get all the possible elements that the user can interact with
      const elements = Array.from(
        this._root.querySelectorAll(this.constructor.focusableElementsString)
      );
  
      // Get the focusable element from top bottom
      this._firstTabStop = this._getFocusableElement(elements);
      // Get the focusable element from bottom up
      this._lastTabStop = this._getFocusableElement(elements.reverse());
      
      if (this.trapped && !elements.includes(document.activeElement)) {
        this._firstTabStop?.focus()
      }
    }
  
    _getFocusableElement(list) {
      // Find a focusable element
      return list.find((element) => {
        // this is a native API available in most modern browsers
        if (element.checkVisibility) {
          return element.checkVisibility();
        }
        // Get the computed styles of the element
        const styles = getComputedStyle(element);
        // Check if the element is accessible
        // Not an ideal solution though
        if (!(styles.display === 'none') || !(styles.visibility === 'hidden')) {
          return true;
        } else {
          return false;
        }
      });
    }
  
    _onKeyDown(event) {
      // We need atleast two unique elements for it to work
      if (!(this._firstTabStop && this._lastTabStop)) {
        event.preventDefault();
        return;
      }
  
      // If we are on the last element transfer the focus to first element and vice versa
      if (event.key === 'Tab' && event.shiftKey) {
        if (document.activeElement === this._firstTabStop) {
          // Traverse back
          event.preventDefault();
          this._lastTabStop.focus();
        }
      } else if (event.keyCode === 9) {
        if (document.activeElement === this._lastTabStop) {
          // Traverse forward
          event.preventDefault();
          this._firstTabStop.focus(); 
        }
      }
    }
  
    /**
     * Trap the user's focus, this effects until unTrap is called
     *
     * @memberof FocusTrap
     */
    trap() {
      this._root.addEventListener('keydown', this._onKeyDown);
      
      this.trapped = true;
  
      // Focus the first element, if any
      if (this._firstTabStop) {
        this._firstTabStop.focus();
      } else {
        this._root.focus();
      }
    }
  
    /**
     * Stop trapping the users focus
     *
     * @memberof FocusTrap
     */
    release() {
      // Remove the event listeners
      this._root.removeEventListener('keydown', this._onKeyDown);
      
      this.trapped = false;
    }
  
    /**
     * Query selector string for possbile focusable elements
     *
     * @readonly
     * @static
     * @memberof FocusTrap
     */
    static get focusableElementsString() {
      // All possible focusable elements
      return [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'datalist:not([disabled])',
        'iframe',
        'object',
        'embed',
        '[tabindex]:not([tabindex="-1"])',
        '[contenteditable]'
      ].join();
    }
  }
  
  let customerPopup = document.querySelector('.login-popup');
  
  let customerLogin = customerPopup.querySelector('.customer__login__popup');
  let customerForgotPassword = customerPopup.querySelector('.customer__forgot-pass__popup');
  let customerRegister = customerPopup.querySelector('.customer__register__popup');
  let customerPasswordReset = customerPopup?.querySelector('.customer__page--form');

  const focus = new FocusTrap(customerPopup);
  
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  
  const openCustomerPopup = function () {
    let returnToInput = customerPopup.querySelector('input[name="return_to"]');
  
    customerPopup?.querySelectorAll('input').forEach(($field) => {
      $field.classList.remove('is-invalid');
      $field.removeAttribute('aria-invalid');
    });
  
    customerPopup?.querySelectorAll('.field__error-message').forEach(($field) => {
     // $field.classList.add('hidden');
    });
  
    returnToInput.value = getQueryParam('return_to') || getQueryParam('return_url') || window.location.pathname;
  
    if(customerRegister?.querySelector('.form-alert') != undefined)
      for (const item of customerRegister.querySelector('.form-alert').children) {
        item.classList.add('hidden');
      }
  
    customerRegister?.querySelector('#create_customer').classList.remove('hidden');
  
    if (location.hash == '#recover' && customerPopup) {
      customerForgotPassword?.classList.add('customer__page--form--active');
      customerLogin?.classList.remove('customer__page--form--active');
      customerPasswordReset?.classList.add('customer__page--recover');
      customerRegister?.classList.remove('customer__page--form--active');

      customerForgotPassword?.querySelector('#recover-success')?.classList.add('hidden');
      customerForgotPassword?.querySelector('#recover_customer')?.classList.remove('hidden');

      const loginPopupContainer = document.querySelector('.login-popup__container');
      if (!loginPopupContainer?.classList.contains("login-popup__container--active")) {
        loginPopupContainer?.classList.add('login-popup__container--active');
      }

      document.body.classList.add('modal-open');
    }

  
    if (location.hash.includes('#login') && customerPopup) {
      if (location.hash == "#login-checkout") {
        returnToInput.value = "/checkout";
      }
      customerLogin?.classList.add('customer__page--form--active');
      customerForgotPassword?.classList.remove('customer__page--form--active');
      customerRegister?.classList.remove('customer__page--form--active');
      customerPopup?.querySelector('.customer__vit-subheading.customer__login').classList.add('active');
      customerPopup?.querySelector('.customer__vit-subheading.customer__register').classList.remove('active');
      if(!document.querySelector('.login-popup__container')?.classList.contains("login-popup__container--active"))
        document.querySelector('.login-popup__container')?.classList.add('login-popup__container--active');
      document.body.classList.add('modal-open');
    }
  
    if (location.hash == '#register' && customerPopup) {
      customerRegister?.classList.add('customer__page--form--active');
      customerForgotPassword?.classList.remove('customer__page--form--active');
      customerLogin?.classList.remove('customer__page--form--active');
      customerPopup?.querySelector('.customer__vit-subheading.customer__register').classList.add('active');
      customerPopup?.querySelector('.customer__vit-subheading.customer__login').classList.remove('active');
      if(!document.querySelector('.login-popup__container')?.classList.contains("login-popup__container--active"))
        document.querySelector('.login-popup__container')?.classList.add('login-popup__container--active');
      document.body.classList.add('modal-open');
    }
    setTimeout(()=>{
      const height = Math.max(customerPopup?.querySelector(".customer__vit").clientHeight, customerPopup?.querySelector(".customer__page--form").clientHeight)
      customerPopup?.querySelector(".divider").setAttribute("style", `height: ${height}px`);
    }, 100)
  
    new MutationObserver((mutations) => {
      mutations.forEach(mu => {
        if (mu.type !== "attributes" && mu.attributeName !== "class") return;
        if(mu.target.classList.contains("login-popup__container--active"))
          focus.trap();
      });
    }).observe(document.querySelector(".login-popup__container"), {attributes: true});
  
    const changeTab = ()=>{
      if(customerLogin.classList.contains("customer__page--form--active")){
        location.hash = '#register'
        setTimeout(()=>{
          customerRegister.querySelector("#register-tab").focus();
        }, 200)
      }
      if(customerRegister.classList.contains("customer__page--form--active")){
        location.hash = '#login'
        setTimeout(()=>{
          customerLogin.querySelector("#login-tab").focus();
        }, 200)
      }
    }
    document.querySelectorAll(".customer__page-title-tabs").forEach(item=>{
      item.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          changeTab();
        }
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          changeTab();
        }
        if (e.key === "Home") {
          e.preventDefault();
          changeTab();
        }
        if (e.key === "End") {
          e.preventDefault();
          changeTab();
        }
      });
    })
  };
  
  openCustomerPopup();
  
    // document.addEventListener("calpak:loaded", function () {
    //   openCustomerPopup();
    // })
  
  window.addEventListener('hashchange', openCustomerPopup, false);
  
  window.addEventListener("click", async (e) => {
    if (
        e.target.classList.contains("login-popup__overlay") ||
        e.target.classList.contains("popup-close")
    ) {
      e.preventDefault();
      closePopup();
    }
  });
  function closePopup() {
    document.querySelector('.login-popup__container').classList.remove('login-popup__container--active');
    customerForgotPassword?.classList.remove('customer__page--form--active');
    customerLogin?.classList.add('customer__page--form--active');
    customerRegister?.classList.remove('customer__page--form--active');
    location.hash = '';
    document.body.classList.remove('modal-open');
    focus.release();
    document.body.focus();
  }
  customerPopup.addEventListener('keydown', e => e.key == 'Escape' && closePopup())
  
  })();